import { Route, Routes } from "react-router";

import { PaymentDetailPage } from "./pages/PaymentDetailPage";
import { PaymentsListPage } from "./pages/PaymentsListPage";

/** The payment routes, mounted at `/payments/*` (CHT-759): the list and one payment. */
export function PaymentsRoutes() {
  return (
    <Routes>
      <Route index element={<PaymentsListPage />} />
      <Route path=":paymentRequestId" element={<PaymentDetailPage />} />
    </Routes>
  );
}
